import { Game } from '../srm/srm-parser'
import { getPath } from '../utils'

const EQUIPMENT_ITEMS: [string, string[]][] = [
  ['Morph Ball', ['morphBall']],
  ['Bombs', ['bombs']],
  ['Spring Ball', ['springBall']],
  ['High Jump Boots', ['highJumpBoots']],
  ['Speed Booster', ['speedBooster']],
  ['Space Jump', ['spaceJump']],
  ['Screw Attack', ['screwAttack']],
  ['Varia Suit', ['suits', 'varia']],
  ['Gravity Suit', ['suits', 'gravity']],
  ['Grapple Beam', ['grapple']],
  ['X-Ray Scope', ['xRay']],
  ['Charge Beam', ['beams', 'charge']],
  ['Ice Beam', ['beams', 'ice']],
  ['Wave Beam', ['beams', 'wave']],
  ['Spazer', ['beams', 'spazer']],
  ['Plasma Beam', ['beams', 'plasma']]
]

function EquipmentSection({
  equipment,
  onUpdate
}: {
  equipment: Game['equipment']
  onUpdate: (
    path: string[],
    bit: 'collected' | 'inInventory' | 'equipped',
    value: boolean
  ) => void
}) {
  return (
    <div className="card-section">
      <h3 className="section-title">Equipment</h3>
      <table className="equipment-table">
        <thead>
          <tr>
            <th />
            <th>Collected</th>
            <th>In Inv.</th>
            <th>Equipped</th>
          </tr>
        </thead>
        <tbody>
          {EQUIPMENT_ITEMS.map(([name, path]) => {
            const item = getPath(equipment, path) as {
              collected: boolean
              inInventory: boolean
              equipped: boolean
            }
            return (
              <tr key={name}>
                <td className="equipment-name">{name}</td>
                {(['collected', 'inInventory', 'equipped'] as const).map((bit) => (
                  <td key={bit} className="equipment-check-cell">
                    <input
                      type="checkbox"
                      checked={item[bit]}
                      onChange={(e) => onUpdate(path, bit, e.target.checked)}
                    />
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default EquipmentSection
